// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"22678e56","902":"1fb036fd"}[chunkId] + ".chunk.js";
};